import React from "react";
import { humanReadableBytes } from "@sscs/utils";
import { SoftwareInfo } from "Components";
import { FileSoftwareInfo, UrlImportData } from "Types";

type OverviewProps = {
  urlImportData: UrlImportData;
  softwareInfo: FileSoftwareInfo;
  fileSize: number | null;
  remainingAfterImport: number;
};

const Overview = ({
  urlImportData,
  softwareInfo,
  fileSize,
  remainingAfterImport,
}: OverviewProps): React.JSX.Element => {
  return (
    <SoftwareInfo.Overview
      softwareInfo={softwareInfo}
      isVersion={false}
      title="Software information"
      leadingList={[
        {
          "Importing from": urlImportData.url,
          "Estimated file size": fileSize
            ? humanReadableBytes(fileSize)
            : "Unknown",
          ...(fileSize
            ? {
                "Remaining capacity after import":
                  humanReadableBytes(remainingAfterImport),
              }
            : {}),
        },
      ]}
    />
  );
};

export default Overview;
